import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import {
  generateInvitationLink,
  resendInvitation,
  revokeInvitation,
} from '@/api/invitations/invitationsApi';
import type { Invitation, InvitationWithLink } from '@/api/invitations/invitationsApi.types';
import { INVITATIONS_QUERY_KEY, TENANTS_QUERY_KEY } from '@/constants/queryKeys';

export function useResendInvitationMutation(): UseMutationResult<InvitationWithLink, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resendInvitation,
    onSuccess: function invalidateInvitations() {
      queryClient.invalidateQueries({ queryKey: INVITATIONS_QUERY_KEY });
    },
  });
}

export function useGenerateInvitationLinkMutation(): UseMutationResult<
  InvitationWithLink,
  Error,
  string
> {
  return useMutation({
    mutationFn: generateInvitationLink,
  });
}

export function useRevokeInvitationMutation(): UseMutationResult<Invitation, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: revokeInvitation,
    onSuccess: function invalidateInvitationsAndWorkspaces() {
      queryClient.invalidateQueries({ queryKey: INVITATIONS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });
    },
  });
}
